import { WidgetType } from "@codemirror/view";

const symbols = {
    footnote: "*",
    endnote: "\u2020",
};

export class FootnoteWidget extends WidgetType {
    constructor(type = "footnote") {
        super();
        this.type = type;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-footnote");
        element.setAttribute("role", "button");
        element.innerHTML = symbols[this.type];
        return element;
    }

    eq(widget) {
        return this.type === widget.type;
    }

    updateDOM(element) {
        element.innerHTML = symbols[this.type];
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
